"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'company.preview.title': 'Company Details',
    'company.preview.failedToLoad': 'Failed to load company information',
    'company.preview.noCompany': 'No company information available',
    'company.preview.section.basic_info': 'Basic Information',
    'company.preview.section.status': 'Status',
    'company.preview.section.location': 'Location',
    'company.preview.section.additional': 'Additional Information',
};
